module.exports = __webpack_public_path__ + "static/media/concepcion-logo.655bf419.jpg";